export function parseUrl(input: string): URL | null {
  try {
    return new URL(input);
  } catch (e) {
    return null;
  }
}
